import { CDN_IMG_URL } from "@workspace/casino_config/cdn";

// Callers pass both "icons/x.svg" and "/icons/x.svg". A doubled slash breaks
// the URL: frontend-ui's Img splits src on "//" to strip the protocol.
const getCdnImg = (src = "", ext = "") =>
  `${CDN_IMG_URL}/${src.replace(/^\/+/, "")}${ext}`;

export default getCdnImg;
